/**
 * D1 Store: Sticky Add to Cart (ATC) JS
 * Triggers the main product form's ATC button
 */

(function() {
  'use strict';
  let cleanupStickyATC = null;

  function initStickyATC() {
    if (cleanupStickyATC) cleanupStickyATC();
    cleanupStickyATC = null;

    const stickyBar = document.querySelector('[data-d1-sticky-atc]');
    const buyBoxTrigger = document.querySelector('[data-d1-buy-box-trigger]');
    const mainSubmitBtn = document.querySelector('[data-d1-main-submit]');
    const stickySubmitBtn = document.querySelector('[data-d1-sticky-submit]');

    if (!stickyBar || !buyBoxTrigger) return;
    const abortController = new AbortController();
    const signal = abortController.signal;
    const observers = [];

    // 1. Visibility — mobile: always on (ATC is often below the fold).
    // Desktop: show only after the buy-box ATC scrolls past the top.
    const mobileMq = window.matchMedia('(max-width: 749px)');
    const isMobileStickyAlwaysOn = () => mobileMq.matches;

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    const isCartOpen = () => Boolean(document.querySelector('cart-drawer.active'));

    const setStickyVisible = (show) => {
      // Skip no-ops — IO/scroll/re-init used to re-toggle + poke Tawk every time (= flicker)
      const next = Boolean(show);
      if (stickyBar.classList.contains('is-visible') === next) return;
      stickyBar.classList.toggle('is-visible', next);
      stickyBar.setAttribute('aria-hidden', next ? 'false' : 'true');
      document.body.classList.toggle('d1-sticky-atc-visible', next);
      // Mobile sticky owns the corner — hide Tawk. Desktop keeps it; CSS lifts it above the bar.
      if (isMobileStickyAlwaysOn()) setTawkVisible(!next);
      else setTawkVisible(true);
    };

    const syncStickyFromBuyBox = () => {
      // Never cover the cart drawer (same z-index stack as sticky).
      if (isCartOpen()) {
        setStickyVisible(false);
        return;
      }
      if (isMobileStickyAlwaysOn()) {
        setStickyVisible(true);
        return;
      }
      const rect = buyBoxTrigger.getBoundingClientRect();
      setStickyVisible(rect.bottom < 0);
    };

    const onMobileMqChange = () => {
      syncStickyFromBuyBox();
      setTawkVisible(!(isMobileStickyAlwaysOn() && stickyBar.classList.contains('is-visible')));
    };

    // Re-bind only — don't slide the bar away (product-info:loaded fires on every variant paint)
    cleanupStickyATC = () => {
      abortController.abort();
      observers.forEach((observer) => observer.disconnect());
      if (typeof mobileMq.removeEventListener === 'function') {
        mobileMq.removeEventListener('change', onMobileMqChange);
      } else if (typeof mobileMq.removeListener === 'function') {
        mobileMq.removeListener(onMobileMqChange);
      }
    };

    function setTawkVisible(visible) {
      const apply = () => {
        try {
          if (!visible) {
            if (!document.body.classList.contains('d1-sticky-atc-visible')) return;
            if (window.Tawk_API && typeof window.Tawk_API.hideWidget === 'function') {
              window.Tawk_API.hideWidget();
            }
            return;
          }
          // Don't resurrect Tawk over cart/search/modals
          if (
            document.querySelector('cart-drawer.active') ||
            document.querySelector('.header__search--drawer details[open]') ||
            document.querySelector('.d1-bundle-modal[aria-hidden="false"]') ||
            document.querySelector('.cr-modal[aria-hidden="false"]') ||
            document.querySelector('.d1-pmg-modal[aria-hidden="false"]') ||
            document.querySelector('pickup-availability-drawer[open]')
          ) {
            return;
          }
          // Custom launcher stays the bubble; do not call showWidget.
        } catch (_) {}
      };
      apply();
      if (!visible) setTimeout(apply, 400);
    }

    // Re-hide if Tawk mounts after sticky is already visible
    try {
      window.Tawk_API = window.Tawk_API || {};
      if (!window.__d1StickyTawkOnLoadBound) {
        window.__d1StickyTawkOnLoadBound = true;
        const prevOnLoad = window.Tawk_API.onLoad;
        window.Tawk_API.onLoad = function () {
          if (typeof prevOnLoad === 'function') prevOnLoad.apply(this, arguments);
          if (
            document.body.classList.contains('d1-sticky-atc-visible') &&
            window.matchMedia('(max-width: 749px)').matches &&
            typeof window.Tawk_API.hideWidget === 'function'
          ) {
            window.Tawk_API.hideWidget();
          }
        };
      }
    } catch (_) {}

    const observer = new IntersectionObserver(() => {
      syncStickyFromBuyBox();
    }, observerOptions);

    observers.push(observer);
    observer.observe(buyBoxTrigger);

    // Hide/show when cart opens/closes (class toggled on <cart-drawer>)
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof MutationObserver === 'function') {
      const cartObserver = new MutationObserver(syncStickyFromBuyBox);
      cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
      observers.push(cartObserver);
    }

    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', onMobileMqChange);
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(onMobileMqChange);
    }

    // First paint: mobile sticky on immediately; desktop uses scroll position
    syncStickyFromBuyBox();
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        if (signal.aborted) return;
        syncStickyFromBuyBox();
      });
    }

    // 2. Trigger main ATC from sticky button
    if (stickySubmitBtn && mainSubmitBtn) {
      stickySubmitBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (mainSubmitBtn.getAttribute('data-d1-awaiting-bundle') === 'true') {
          if (window.d1BundleTiers && typeof window.d1BundleTiers.requireChoice === 'function') {
            window.d1BundleTiers.requireChoice();
          }
          return;
        }

        // Disable button to prevent double clicks
        stickySubmitBtn.setAttribute('disabled', 'disabled');
        stickySubmitBtn.classList.add('loading');

        // Trigger the main button
        mainSubmitBtn.click();

        // Re-enable after a short delay (Dawn's AJAX cart will handle the actual response)
        setTimeout(() => {
          stickySubmitBtn.removeAttribute('disabled');
          stickySubmitBtn.classList.remove('loading');
        }, 1000);
      }, { signal });
    }

    // Sticky bar already shows price beside the button — don't repeat it in the label
    function stickyButtonLabel(raw) {
      const text = (raw || '').trim();
      if (!text) return window.variantStrings?.addToCart || 'Add to Cart';
      if (/sold\s*out/i.test(text)) return text;
      return text.replace(/\s*[–—-]\s*\$[\d,]+(?:\.\d{2})?\s*$/, '').trim()
        || (window.variantStrings?.addToCart || 'Add to Cart');
    }

    // 2.1 Mirror main submit button state (label without price)
    function syncStickyButton() {
      if (!mainSubmitBtn || !stickySubmitBtn) return;

      const mainTextSpan = mainSubmitBtn.querySelector('span');
      const stickyTextSpan = stickySubmitBtn.querySelector('span');

      if (mainTextSpan && stickyTextSpan) {
        stickyTextSpan.textContent = stickyButtonLabel(mainTextSpan.textContent);
      }

      const awaitingBundle = mainSubmitBtn.getAttribute('data-d1-awaiting-bundle') === 'true';
      stickySubmitBtn.classList.toggle('is-awaiting-bundle', awaitingBundle);
      if (mainSubmitBtn.hasAttribute('disabled')) {
        stickySubmitBtn.setAttribute('disabled', 'disabled');
      } else {
        stickySubmitBtn.removeAttribute('disabled');
      }
    }

    // Initial sync
    syncStickyButton();

    // Declared before syncStickyTotalPrice — used as fallback total when ATC label has no price
    let productCache = null;
    const cacheEl = stickyBar.querySelector('[data-d1-sticky-product-json]');
    if (cacheEl) {
      try {
        productCache = JSON.parse(cacheEl.textContent);
      } catch (err) {
        console.error("Failed parsing sticky product JSON:", err);
      }
    }

    // Observe changes to the main button text or attributes (like disabled)
    if (mainSubmitBtn) {
      const mainBtnObserver = new MutationObserver(() => {
        syncStickyButton();
        syncStickyTotalPrice();
      });
      observers.push(mainBtnObserver);
      mainBtnObserver.observe(mainSubmitBtn, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled']
      });
    }

    // ── Bundle selection (mirrors PDP tier radios) ───────────────
    const bundleWrap = stickyBar.querySelector('[data-d1-sticky-bundle-wrap]');
    const bundleSelect = stickyBar.querySelector('[data-d1-sticky-bundle-select]');
    let syncingBundle = false;

    function getVisibleBundleTiers() {
      return Array.from(document.querySelectorAll('[data-d1-tier-wrapper]')).filter((w) => {
        return w.style.display !== 'none' && w.offsetParent !== null;
      });
    }

    function formatMoneyCents(cents) {
      const n = (parseInt(cents, 10) || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(n);
      } catch (e) {
        return '$' + n.toFixed(2);
      }
    }

    function rebuildBundleSelect() {
      if (!bundleWrap || !bundleSelect) return;
      const tiers = getVisibleBundleTiers();
      if (tiers.length < 2) {
        bundleWrap.hidden = true;
        bundleSelect.innerHTML = '';
        return;
      }

      const prev = bundleSelect.value;
      bundleSelect.innerHTML = '';
      tiers.forEach((w) => {
        const input = w.querySelector('[data-d1-bundle-tier-input]');
        if (!input) return;
        const id = w.getAttribute('data-tier-id') || input.value;
        const title = w.getAttribute('data-tier-title') || id;
        const addCents = parseInt(w.getAttribute('data-bundle-price-cents') || '0', 10) || 0;
        const opt = document.createElement('option');
        opt.value = id;
        opt.textContent = addCents > 0 ? `${title} (+${formatMoneyCents(addCents)})` : title;
        if (input.checked) opt.selected = true;
        bundleSelect.appendChild(opt);
      });

      if (prev && Array.from(bundleSelect.options).some((o) => o.value === prev)) {
        bundleSelect.value = prev;
      }
      bundleWrap.hidden = false;
    }

    function selectBundleOnPdp(tierId) {
      if (!tierId || syncingBundle) return;
      const match = document.querySelector('[data-d1-tier-wrapper][data-tier-id="' + String(tierId).replace(/"/g, '\\"') + '"]');
      if (!match || match.style.display === 'none') return;
      const input = match.querySelector('[data-d1-bundle-tier-input]');
      if (!input || input.disabled || input.checked) return;
      syncingBundle = true;
      input.checked = true;
      document.querySelectorAll('[data-d1-tier-wrapper]').forEach((w) => w.classList.remove('is-selected'));
      match.classList.add('is-selected');
      input.dispatchEvent(new Event('change', { bubbles: true }));
      syncingBundle = false;
      syncStickyTotalPrice();
    }

    function syncBundleSelectFromPdp() {
      if (!bundleSelect || bundleWrap?.hidden) return;
      const checked = document.querySelector('[data-d1-bundle-tier-input]:checked');
      if (!checked) return;
      const wrap = checked.closest('[data-d1-tier-wrapper]');
      const id = wrap?.getAttribute('data-tier-id') || checked.value;
      if (id && bundleSelect.value !== id) {
        syncingBundle = true;
        bundleSelect.value = id;
        syncingBundle = false;
      }
    }

    // Sticky is tight on mobile — drop compare-at + currency code so the title isn't "D..."
    function tidyStickyPriceMarkup(container) {
      if (!container) return;
      container.querySelectorAll('.price__badge-sale, .price__badge-sold-out, .badge').forEach((n) => n.remove());
      if (container.querySelector('.price--on-sale')) {
        container.querySelectorAll('.price-item--regular').forEach((n) => {
          const wrap = n.parentElement;
          if (wrap && wrap !== container && !wrap.classList.contains('price__sale') && !wrap.classList.contains('price__container')) {
            wrap.remove();
          } else {
            n.remove();
          }
        });
      }
      container.querySelectorAll('.price-item').forEach((n) => {
        n.textContent = String(n.textContent || '').replace(/\s*[A-Z]{3}\s*$/, '').trim();
      });
    }

    function syncStickyTotalPrice() {
      const stickyPriceContainer = stickyBar.querySelector('.d1-sticky-atc__price');
      if (!stickyPriceContainer) return;
      if (document.querySelector('.price--notify-hold')) return;

      // Prefer the main ATC label total (already includes selected bundle)
      const mainText = mainSubmitBtn?.querySelector('span')?.textContent || '';
      const match = mainText.match(/[–—-]\s*(\$[\d,]+(?:\.\d{2})?)/);
      if (match) {
        const priceItem = stickyPriceContainer.querySelector('.price-item--sale, .price-item--regular, .price-item');
        if (priceItem) {
          priceItem.textContent = match[1];
          tidyStickyPriceMarkup(stickyPriceContainer);
          return;
        }
        stickyPriceContainer.innerHTML = `<div class="price"><div class="price__container"><div class="price__regular"><span class="price-item price-item--regular">${match[1]}</span></div></div></div>`;
        return;
      }

      // Fallback: variant price + selected bundle add-on.
      // A listing page has no selected tier. Its rendered price already includes
      // the main item's current web price, so do not replace it with the listing SKU price.
      const checked = document.querySelector('[data-d1-bundle-tier-input]:checked');
      const wrap = checked?.closest('[data-d1-tier-wrapper]');
      const addCents = wrap ? parseInt(wrap.getAttribute('data-bundle-price-cents') || '0', 10) || 0 : 0;
      if (!(addCents > 0)) {
        tidyStickyPriceMarkup(stickyPriceContainer);
        return;
      }
      const form = document.querySelector('form[action*="/cart/add"]');
      const idInput = form?.querySelector('input[name="id"], select[name="id"]');
      const variantId = idInput ? String(idInput.value) : '';
      const variant = productCache?.variants?.find((v) => String(v.id) === variantId);
      if (variant && typeof variant.price === 'number') {
        const total = formatMoneyCents(variant.price + addCents);
        const priceItem = stickyPriceContainer.querySelector('.price-item--sale, .price-item--regular, .price-item');
        if (priceItem) priceItem.textContent = total;
      }
      tidyStickyPriceMarkup(stickyPriceContainer);
    }

    if (bundleSelect) {
      bundleSelect.addEventListener('change', () => {
        if (syncingBundle) return;
        selectBundleOnPdp(bundleSelect.value);
      }, { signal });
    }

    // Keep sticky bundle select + total in sync with PDP tier changes
    const bundleRoot = document.querySelector('[id^="d1-bundle-tiers-"]');
    if (bundleRoot) {
      bundleRoot.addEventListener('change', (e) => {
        if (!e.target.matches('[data-d1-bundle-tier-input]')) return;
        rebuildBundleSelect();
        syncBundleSelectFromPdp();
        syncStickyTotalPrice();
      }, { signal });
    }

    // Rebuild when variant filtering hides/shows tiers
    document.addEventListener('variant:change', () => {
      setTimeout(() => {
        if (signal.aborted) return;
        rebuildBundleSelect();
        syncBundleSelectFromPdp();
        syncStickyTotalPrice();
      }, 200);
    }, { signal });

    rebuildBundleSelect();
    syncBundleSelectFromPdp();
    syncStickyTotalPrice();
    setTimeout(() => {
      if (signal.aborted) return;
      rebuildBundleSelect();
      syncBundleSelectFromPdp();
      syncStickyTotalPrice();
    }, 400);

    // 3. Sync Variant Changes
    const stickySelect = stickyBar.querySelector('[data-d1-sticky-variant-select]');
    if (stickySelect) {
      stickySelect.addEventListener('change', (e) => {
        const selectedVariantId = parseInt(e.target.value);
        if (!selectedVariantId) return;

        if (productCache) {
          syncMainPageVariant(selectedVariantId);
        } else {
          // Robust AJAX fallback parsing URL for handle
          const path = window.location.pathname;
          const match = path.match(/\/products\/([^\/]+)/);
          const ajaxUrl = match && match[1] ? `/products/${match[1]}.js` : `${path}.js`;

          fetch(ajaxUrl)
            .then(res => res.json())
            .then(product => {
              productCache = product;
              syncMainPageVariant(selectedVariantId);
            })
            .catch(err => console.error("Sticky fetch variant error:", err));
        }
      }, { signal });
    }

    function syncMainPageVariant(selectedVariantId) {
      if (!productCache) return;
      const variant = productCache.variants.find(v => v.id === selectedVariantId);
      if (!variant) return;

      const optionsToSet = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      optionsToSet.forEach((val) => {
        // Find matching radio input by checking exact value equality in JS (immune to selector escaping issues)
        const radios = Array.from(document.querySelectorAll('.product-form__input input[type="radio"]'));
        const matchingRadio = radios.find(radio => radio.value === val);

        if (matchingRadio) {
          if (!matchingRadio.checked) {
            matchingRadio.checked = true;
            // Dispatch change event to bubble up and trigger Dawn's product-info AJAX renderer
            matchingRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          // Fallback to select dropdowns
          const selects = Array.from(document.querySelectorAll('.product-form__input select'));
          selects.forEach(select => {
            const option = Array.from(select.options).find(opt => opt.value === val);
            if (option && select.value !== val) {
              select.value = val;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
      });
    }

    document.addEventListener('variant:change', (e) => {
      const { variantId, form, variant } = e.detail;
      if (!variantId && !variant) return;

      if (variant) {
        updateStickyUI(variant);
      } else {
        // Fetch variant info if not provided, but cache it
        if (productCache) {
          const selectedVariant = productCache.variants.find(v => v.id === parseInt(variantId));
          if (selectedVariant) updateStickyUI(selectedVariant);
        } else {
          const path = window.location.pathname;
          const match = path.match(/\/products\/([^\/]+)/);
          const ajaxUrl = match && match[1] ? `/products/${match[1]}.js` : `${path}.js`;

          fetch(ajaxUrl)
            .then(res => res.json())
            .then(product => {
              productCache = product;
              const selectedVariant = product.variants.find(v => v.id === parseInt(variantId));
              if (selectedVariant) updateStickyUI(selectedVariant);
            })
            .catch(err => console.error("Sticky fetch variant change error:", err));
        }
      }
    }, { signal });

    function updateStickyUI(variant) {
      const animateElements = [
        stickyBar.querySelector('.d1-sticky-atc__subtitle'),
        stickyBar.querySelector('.d1-sticky-atc__price'),
        document.querySelector('.sku-value'),
        document.querySelector('.ean-value')
      ].filter(el => el !== null);

      animateElements.forEach(el => el.classList.add('variant-updating'));

      setTimeout(() => {
        if (signal.aborted) return;
        const stickySubtitle = stickyBar.querySelector('.d1-sticky-atc__subtitle');
        if (stickySubtitle) {
          const pillsApi = window.D1CardVariantPills;
          const careLabel =
            pillsApi && typeof pillsApi.stickyPlanLabel === 'function' ? pillsApi.stickyPlanLabel() : '';
          stickySubtitle.textContent =
            careLabel || (variant.title && variant.title !== 'Default Title' ? variant.title : '');
        }

        const stickyImage = stickyBar.querySelector('.d1-sticky-atc__image');
        if (stickyImage && variant.featured_image) {
          stickyImage.src = variant.featured_image.src.replace(/\.(jpg|jpeg|png|gif|webp)/, '_100x.$1');
        }

        const isAvailable = variant.available;
        if (stickySubmitBtn) {
          if (isAvailable) {
            stickySubmitBtn.removeAttribute('disabled');
          } else {
            stickySubmitBtn.setAttribute('disabled', 'disabled');
          }
          // Mirror main ATC (incl. Pre-Order) — don't hardcode Add to Cart.
          syncStickyButton();
          if (!isAvailable) {
            const stickyBtnText = stickySubmitBtn.querySelector('span');
            if (stickyBtnText) {
              stickyBtnText.textContent = window.variantStrings?.soldOut || 'Sold Out';
            }
          }
        }

        const mainPrice = document.querySelector('#price-' + stickyBar.dataset.sectionId);
        const stickyPriceContainer = stickyBar.querySelector('.d1-sticky-atc__price');
        if (mainPrice && stickyPriceContainer) {
          stickyPriceContainer.innerHTML = mainPrice.innerHTML;
          tidyStickyPriceMarkup(stickyPriceContainer);
        }
        syncStickyTotalPrice();

        const stickyStock = stickyBar.querySelector('[data-d1-sticky-stock]');
        if (stickyStock) {
          const stickyDot = stickyStock.querySelector('.product__inventory-status-dot');
          const stickyLabel = stickyStock.querySelector('.product__price-stock-label');
          if (stickyDot && stickyLabel) {
            const mainInventory = document.querySelector('[id^="Inventory-"]');
            const mainDot = mainInventory ? mainInventory.querySelector('.product__inventory-status-dot') : null;
            const mainLabel = mainInventory ? mainInventory.querySelector('.product__inventory-btn-label') : null;

            if (mainDot && mainLabel) {
              stickyDot.className = mainDot.className;
              stickyLabel.textContent = mainLabel.textContent.trim();
            } else if (
              mainSubmitBtn?.getAttribute('data-backorder') === 'true' ||
              mainSubmitBtn?.getAttribute('data-preorder') === 'true'
            ) {
              stickyDot.className = 'product__inventory-status-dot product__inventory--preorder';
              stickyLabel.textContent = 'Currently Pre-Ordering';
            } else if (variant.available) {
              stickyDot.className = 'product__inventory-status-dot product__inventory--available';
              stickyLabel.textContent = 'In-Stock';
            } else {
              stickyDot.className = 'product__inventory-status-dot product__inventory--soldout';
              stickyLabel.textContent = 'Sold Out';
            }
          }
        }

        updateMainPageInfo(variant);
        animateElements.forEach(el => el.classList.remove('variant-updating'));
      }, 150);
    }

    function updateMainPageInfo(variant) {
      // Update Main Title
      const variantTitleElements = document.querySelectorAll('.product-title-variant');
      if (variantTitleElements.length > 0 && variant.title) {
        variantTitleElements.forEach(el => {
          el.textContent = variant.title === 'Default Title' ? '' : variant.title;
        });
      }

      // Update SKU and EAN
      const skuContainer = document.querySelector('[id^="Sku-"]');
      if (skuContainer) {
        if (variant.sku) {
          skuContainer.classList.remove('visibility-hidden');
          const skuValue = skuContainer.querySelector('.sku-value');
          if (skuValue) skuValue.textContent = variant.sku;

          const eanValue = skuContainer.querySelector('.ean-value');
          const eanLabel = skuContainer.querySelector('.ean-label');
          const eanDivider = skuContainer.querySelector('.sku-divider');

          if (variant.barcode) {
            if (eanValue) {
              eanValue.textContent = variant.barcode;
              eanValue.style.display = 'inline';
            }
            if (eanLabel) eanLabel.style.display = 'inline';
            if (eanDivider) eanDivider.style.display = 'inline';
          } else {
            if (eanLabel) eanLabel.style.display = 'none';
            if (eanDivider) eanDivider.style.display = 'none';
            if (eanValue) eanValue.style.display = 'none';
          }
        } else {
          skuContainer.classList.add('visibility-hidden');
        }
      }
    }
  }

  // One boot path — product-info:loaded also fires on connect (avoid double-init flicker)
  let bootScheduled = false;
  function scheduleInitStickyATC() {
    if (bootScheduled) return;
    bootScheduled = true;
    requestAnimationFrame(() => {
      bootScheduled = false;
      initStickyATC();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInitStickyATC, { once: true });
  } else {
    scheduleInitStickyATC();
  }

  // Theme editor + product swaps (full product-info replace)
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-d1-sticky-atc]')) {
      scheduleInitStickyATC();
    }
  });
  document.addEventListener('product-info:loaded', scheduleInitStickyATC);

})();
